import { render } from "./GroupDetailsView.vue?vue&type=template&id=24159d05&scoped=true&ts=true"
import script from "./GroupDetailsView.vue?vue&type=script&lang=ts"
export * from "./GroupDetailsView.vue?vue&type=script&lang=ts"

import "./GroupDetailsView.vue?vue&type=style&index=0&id=24159d05&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24159d05"]])

export default __exports__